import script from "./RecoveryAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./RecoveryAccount.vue?vue&type=script&setup=true&lang=js"

import "./RecoveryAccount.vue?vue&type=style&index=0&id=79782ec2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79782ec2"]])

export default __exports__